import axios from 'axios';
import util from './util';
import router from '../router';
import { MessageBox } from 'element-ui';

const http = axios.create({
  baseURL: process.env.BASE_API + '/Apps/JYJYManage/',
  timeout: 60000,
  headers: {
    'Authorization': util.cookies.get('access_token')
  }
});

// Add a request interceptor
http.interceptors.request.use(function (config) {
  // Do something before request is sent
  // if (config.url.indexOf('/CreateToken') == -1 &&
  //     config.url.indexOf('/SendSMSCode') == -1 &&
  //     config.url.indexOf('/RegistUser') == -1 &&
  //     !util.cookies.get('access_token')) {
  //     MessageBox.alert('请先登录', '提示', {
  //         confirmButtonText: '确定',
  //         callback: () => {
  //             router.push('index')
  //             window.location.reload()
  //         }
  //     })
  // }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
      case 403:
        MessageBox.alert('请重新登录', '提示', {
          confirmButtonText: '确定',
          callback: () => {
            util.cookies.remove('access_token');
            util.cookies.remove('usertype');
            router.push('index');
            window.location.reload();
          }
        });

    }
  }
  // Do something with response error
  return Promise.reject(error);
});

export default http;


// WEBPACK FOOTER //
// ./src/libs/axios.js